// src/components/ui/DemoDialog.jsx
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";

export default function DemoDialog({ open, onClose }) {
  const [form, setForm] = useState({ name: "", phone: "" });

  const handleChange = (e) =>
    setForm((s) => ({ ...s, [e.target.name]: e.target.value }));

  async function handleSubmit(e) {
    e.preventDefault();
    const { name, phone } = form;
    if (!name || !phone) {
      alert("يرجى تعبئة جميع الحقول المطلوبة");
      return;
    }
    const rx = /^05\d{8}$/;
    if (!rx.test(phone)) {
      alert("رقم الهاتف غير صحيح. يجب أن يبدأ بـ 05 ويتبعه 8 أرقام.");
      return;
    }

    try {
      const res = await fetch(
        "https://supportapi.esnadofficial.com/api/DemoCustomers",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Name: name.trim(), Phone: phone.trim() }),
        }
      ).then((r) => r.json());

      if (res.success) {
        setForm({ name: "", phone: "" });
        onClose();
        window.location.href = "https://demo.esnadofficial.com";
      } else if (res.errors?.Phone) {
        setForm({ name: "", phone: "" });
        onClose();
        window.location.href = "https://demo.esnadofficial.com";
      } else {
        alert("حدث خطأ أثناء إرسال الرسالة.");
      }
    } catch (err) {
      console.error(err);
      alert("تعذر الاتصال بالخادم.");
    }
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ fontWeight: 900, textAlign: "center" }}>
        أدخل بياناتك
      </DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent sx={{ display: "grid", gap: 2 }}>
          <TextField
            label="الاسم"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
            fullWidth
          />
          <TextField
            label="رقم الجوال"
            name="phone"
            value={form.phone}
            onChange={handleChange}
            required
            fullWidth
            inputProps={{ pattern: "^05\\d{8}$" }}
          />
        </DialogContent>
        <DialogActions sx={{ justifyContent: "space-between", px: 3, pb: 2 }}>
          <Button onClick={onClose} color="error">
            إغلاق
          </Button>
          <Button type="submit" variant="contained" color="success">
            متابعة النسخة التجريبية
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
